import React from "react";
import "../styles/loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-spinner"></div>
      <p className="loader-text">Loading NeivArt...</p>
    </div>
  );
};

export default Loader;
